module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_LS: process.env.REACT_APP_API_URL_LS,
  API_URL_HD: process.env.REACT_APP_API_URL_HD,
  API_URL_FCWC: process.env.REACT_APP_API_URL_FCWC,
  SITE: process.env.REACT_APP_SITE
  // SITE: 'SHBET'
};
